import styled from 'styled-components';
import { Card, Switch } from 'antd';

export const MetricsContentWrapper = styled.div`
  width: 100%;
  height: 50%;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  min-height: 400px;
`;

export const StyledCard = styled(Card)`
  background-color: #fff;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  min-width: 380px;
  border: 1px solid #e5e5e5;

  .ant-card-head-title {
    font-size: 16px;
    font-weight: 400;
  }

  .ant-card-head {
    border-bottom: 0;
    padding: 0 10px;
  }

  .ant-card-body {
    padding: 6px;
    flex-grow: 1;
    position: relative;
    overflow: auto;
  }

  &:hover {
    box-shadow: rgb(0 0 0 / 25%) 0 2px 2px 0;

    .drag-handle {
      opacity: 1;
    }
  }
`;

export const ChartWrapper = styled.div`
  position: relative;
  overflow: hidden;
  flex: 1;
`;

export const StyledSwitch = styled(Switch)`
  background: rgb(0 0 0 / 39%);
`;
